module.exports = __webpack_public_path__ + "inf_prod_512.png";